import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servTensaoFornecimento from "../../services/login/servTensaoFornecimento";

const TensaoFornecimentoSearchField = ({ id, field, setErrorMessage, setOpenError, setValue, value, editavel, required }) => {
    
    const loadTensoesFornecimentos = async () => {
        try {
            const response = await servTensaoFornecimento.Listar();
            let data = response.Content.map(mapResponseToValuesAndLabels);
            return data;
        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    }

    const mapResponseToValuesAndLabels = (data) => {
       let label = `${data.Id} - ${data.Descricao}`;
       return { value: data.Id, label: label };
    }

    const campoComValorErrado = {
        borderRadius: '10px',
        borderBottom: '3px solid #e03528',
    };
    

    const combinedStyles = {
        ...SearchFieldStyles,
        control: (base, state) => ({
            ...SearchFieldStyles.control(base, state),
            ...(required ? campoComValorErrado : {}),
            '&:hover': {
                ...(required ? campoComValorErrado : {}),
            },
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: '200px',
            overflowY: 'auto',
            margin: 0,
            padding: 0,
        }),
    };

    return (
        <AsyncSelect 
            id={id}
            placeholder="Tensão nominal (V)"
            loadOptions={loadTensoesFornecimentos}
            defaultOptions
            styles={combinedStyles}
            isDisabled={editavel}
            {...field}
            value={value} 
            onChange={(data) => {
                const selectedValue = { value: data.value, label: data.label };
                field.onChange(selectedValue);
                setValue(selectedValue);
            }}
            required={required}
        />
    );
}

export { TensaoFornecimentoSearchField };
